// Sprint 8 — Push notification API schemas.
import { z } from 'zod';
export const FcmPlatformSchema = z.enum(['ANDROID', 'IOS', 'WEB']);
export const RegisterFcmTokenRequestSchema = z.object({
    /** FCM device token, up to ~200 chars. */
    token: z.string().min(20).max(4096),
    platform: FcmPlatformSchema,
    /** Optional human label like "Xiaomi Redmi 10" or "Pixel 7". */
    device_label: z.string().max(128).optional(),
});
export const RegisterFcmTokenResponseSchema = z.object({
    ok: z.literal(true),
});
export const UnregisterFcmTokenRequestSchema = z.object({
    token: z.string().min(20).max(4096),
});
//# sourceMappingURL=push.js.map